import { TranslateService } from '@ngx-translate/core';
// import moment  from 'moment';
import { Injectable, Injector } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpParams,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { mergeMap, tap } from 'rxjs/operators';
import { CoreConfigService } from '../core.service';

@Injectable()
export class CoreInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const _CoreConfigService = this.injector.get(CoreConfigService);
    if (_CoreConfigService.Setting.lang) {
      request = request.clone({
        setHeaders: {
          'kett-lang': _CoreConfigService.Setting.lang,
        },
      });
    }
    if (document.getElementById('xkeid')) {
      request = request.clone({
        setHeaders: {
          'X-KE-ID': document.getElementById('xkeid').getAttribute('value'),
        },
      });
    }

    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (event.headers.get('X-KE-ID')) {
            document
              .getElementById('xkeid')
              .setAttribute('value', event.headers.get('X-KE-ID'));
          }
        }
        return event;
      })
    );
  }
}
